<template>
  <canvas ref="canvasRef" :width="currentWidth" :height="currentHeight" />
</template>

<script lang="ts" setup>
import { decode } from 'blurhash'
import { computed, nextTick, onMounted, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    hash: string
    width?: number | string
    height?: number | string
    punch?: number | string
  }>(),
  {
    width: 200,
    height: 200,
    punch: 1,
  },
)

const canvasRef = ref<HTMLCanvasElement | null>(null)

const toNumber = (input: string | number) => (typeof input === 'number' ? input : parseInt(input, 10))
const currentPunch = computed(() => toNumber(props.punch))
const ratio = computed(() => toNumber(props.width) / toNumber(props.height))

const currentWidth = 32
const currentHeight = computed(() => Math.ceil(currentWidth / ratio.value))

const drawCanvas = () => {
  if (props.hash.length < 6) {
    return
  }

  const pixels = decode(props.hash, currentWidth, currentHeight.value, currentPunch.value)
  const ctx = (canvasRef.value as HTMLCanvasElement).getContext('2d')

  const imageData = ctx!.createImageData(currentWidth, currentHeight.value)
  imageData.data.set(pixels)
  ctx!.putImageData(imageData, 0, 0)
}

watch(props, async () => {
  await nextTick()
  drawCanvas()
})

onMounted(async () => {
  drawCanvas()
})
</script>
